import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import {
  CftLayout,
  CftHeader,
  CftSection,
  CftBox,
  CftProgressCircle,
  CftActionsButtons,
  CftTank,
  CftExportReport,
  CftLeavingModal,
} from "../../../components";
import { ReactComponent as CropIcon } from "../../../../assets/icons/cft/crops.svg";
import { ReactComponent as SoilIcon } from "../../../../assets/icons/cft/ochrona_gleba.svg";
import { ReactComponent as IrrigationIcon } from "../../../../assets/icons/cft/irygacja.svg";
import { ReactComponent as ReportIcon } from "../../../../assets/icons/cft/detale.svg";
import routes from "../../../utils/cftRoutes";
import { useCft } from "../../../utils/CftProvider";

import "../../styles/progressDashboard.scss";

export default function WaterFootprintPage() {
  const { t } = useTranslation(["cft"]);
  const history = useHistory();
  const { meta, progress } = useCft();
  const [showLeavingModal, setShowLeavingModal] = useState(false);
  const stopOverflow = () => {
    document.querySelector("body").style.overflowY = "hidden";
    document.querySelector("html").style.overflow = "hidden";
  };

  return (
    <CftLayout
      header={
        <CftHeader
          cropName={meta.title.waterFootprint}
          actions={
            <CftTank
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <CftActionsButtons.GoToProfile
                onClick={() => {
                  stopOverflow();
                  setShowLeavingModal(!showLeavingModal);
                }}
              />
            </CftTank>
          }
        />
      }
    >
      <CftSection
        header={
          <CftTank display="flex" flexDirection="row" alignItems="center">
            <h3 className="progress-dashboard-header cft-wrapper">
              {meta.title.waterFootprint}
            </h3>
            <CftExportReport type="waterFootprint" />
          </CftTank>
        }
      >
        <div className="progress-dashboard cft-wrapper water-footprint">
          <CftBox
            onClick={() =>
              history.push(routes.FARMLANDS.WATER_FOOTPRINT.DETAILS)
            }
          >
            <div className="progress-dashboard__box">
              <CftProgressCircle
                value={progress.waterFootprint.details.complete}
              />
              <CropIcon />
              <p>{t("cft:types.detailsWaterFootprint", "Detale uprawy")}</p>
            </div>
          </CftBox>
          <CftBox
            onClick={() => history.push(routes.FARMLANDS.WATER_FOOTPRINT.SOIL)}
          >
            <div className="progress-dashboard__box">
              <CftProgressCircle
                value={progress.waterFootprint.soil.complete}
              />
              <SoilIcon />
              <p>{t("cft:types.soil", "Gleba")}</p>
            </div>
          </CftBox>
          <CftBox
            onClick={() =>
              history.push(routes.FARMLANDS.WATER_FOOTPRINT.IRRIGATION)
            }
          >
            <div className="progress-dashboard__box">
              <CftProgressCircle
                value={progress.waterFootprint.irrigation.complete}
              />
              <IrrigationIcon />
              <p>{t("cft:types.irrigation")}</p>
            </div>
          </CftBox>
          <CftBox
            onClick={() =>
              history.push(routes.FARMLANDS.WATER_FOOTPRINT.REPORT)
            }
          >
            <div className="progress-dashboard__box">
              <CftProgressCircle
                value={(
                  (progress.waterFootprint.details.complete +
                    progress.waterFootprint.soil.complete +
                    progress.waterFootprint.irrigation.complete) /
                  3
                ).toFixed()}
              />
              <ReportIcon />
              <p>{t("cft:types.report", "Raport")}</p>
            </div>
          </CftBox>
        </div>
        <CftLeavingModal
          isVisible={showLeavingModal}
          hide={() => setShowLeavingModal(!showLeavingModal)}
          type="waterFootprint"
          goToProfile={() => history.push(routes.MAIN)}
        />
      </CftSection>
    </CftLayout>
  );
}
